import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getPersonCertificationBadgeByFileUrlData = (fileUrl, state, setState) => {
  if (fileUrl) {
    const api = initApi(API_NAMES.PERSON, state, setState);
    const fileUrlForUrl = encodeURIComponent(fileUrl);
    const url = `/PersonFiles/certificationBadge?fileUrl=${fileUrlForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'GET', null, false, true) : null;
  }
};

const PersonCertificationBadgeData = {
  getPersonCertificationBadgeByFileUrlData
};

export default PersonCertificationBadgeData;